import { ED_CONTEXT_MENU_TYPES } from '../ed-context-menu.values';

export class EdContextMenuModel {
  position = {x: 0, y: 0};
  type: string;
  options: any[];
  className: string;
  offsetX: number;
  backdrop: boolean;
  headerComponent: string;
  darkMode?: boolean;

  constructor({
    position = {x: 0, y: 0},
    options = [],
    type = ED_CONTEXT_MENU_TYPES.ITEMS,
    className = '',
    offsetX = 0,
    backdrop = false,
    headerComponent = '',
    darkMode = false
  }) {
    this.type = type;
    this.position = position;
    this.options = options;
    this.className = className;
    this.offsetX = offsetX;
    this.headerComponent = headerComponent;
    this.backdrop = backdrop;
    this.darkMode = darkMode;
  }
}
